<template>
    <div class="single-filter range-filter-dropdown">
        <div class="dropdown keep-inside-clicks-open">
            <button class="btn btn-filter"
                    :class="{'applied': isApply}"
                    :id="filterId"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                {{ filterLabel }}
                <span class="clear-icon" v-if="isApply" @click.prevent="clear">
                    <app-icon :name="'x'"/>
                </span>
            </button>
            <div class="dropdown-menu" :aria-labelledby="filterId">
                <div class="btn-dropdown-close d-sm-none">
                    <span class="title">
                        {{ filterLabel }}
                    </span>
                    <span class="back float-right" @click.prevent="closeDropDown">
                        <app-icon :name="'x'"/>
                    </span>
                </div>
                <div class="dropdown-item">
                    <div class="mt-4 mb-2 text-center"><b>{{ firstTitle }}</b></div>
                    <div :id="'slider-first-'+filterId"/>
                    <div class="rate-status mt-primary d-flex justify-content-center">
                        <div class="min-rate">
                            <p class="text-center">{{ firstMinTitle }}</p>
                            <input class="text-center mw-100 border-0 bg-transparent" v-model="sliderFirstMinRange" @input="updateFirstRange($event.target.value, sliderFirstMaxRange)"/>
                        </div>
                        <hr>
                        <div class="max-rate">
                            <p class="text-center">{{ firstMaxTitle }}</p>
                            <input class="text-center mw-100 border-0 bg-transparent" v-model="sliderFirstMaxRange" @input="updateFirstRange(sliderFirstMinRange, $event.target.value)"/>
                        </div>
                    </div>
                    <div class="mt-4 mb-2 text-center"><b>{{ secondTitle }}</b></div>
                    <div :id="'slider-second-'+filterId"/>
                    <div class="rate-status mt-primary d-flex justify-content-center">
                        <div class="min-rate">
                            <p class="text-center">{{ secondMinTitle }}</p>
                            <input class="text-center mw-100 border-0 bg-transparent" v-model="sliderSecondMinRange" @input="updateSecondRange($event.target.value, sliderSecondMaxRange)"/>
                        </div>
                        <hr>
                        <div class="max-rate">
                            <p class="text-center">{{ secondMaxTitle }}</p>
                            <input class="text-center mw-100 border-0 bg-transparent" v-model="sliderSecondMaxRange" @input="updateSecondRange(sliderSecondMinRange, $event.target.value)"/>
                        </div>
                    </div>
                    <div class="mt-4 mb-2 text-center"><b>{{ thirdTitle }}</b></div>
                    <div :id="'slider-third-'+filterId"/>
                    <div class="rate-status mt-primary d-flex justify-content-center">
                        <div class="min-rate">
                            <p class="text-center">{{ thirdMinTitle }}</p>
                            <input class="text-center mw-100 border-0 bg-transparent" v-model="sliderThirdMinRange" @input="updateThirdRange($event.target.value, sliderThirdMaxRange)"/>
                        </div>
                        <hr>
                        <div class="max-rate">
                            <p class="text-center">{{ thirdMaxTitle }}</p>
                            <input class="text-center mw-100 border-0 bg-transparent" v-model="sliderThirdMaxRange" @input="updateThirdRange(sliderThirdMinRange, $event.target.value)"/>
                        </div>
                    </div>
                    <div class="mt-4 mb-2 text-center"><b>{{ stakeTitle }}</b></div>
                    <div :id="'slider-stake-'+filterId"/>
                    <div class="rate-status mt-primary d-flex justify-content-center">
                        <div class="min-rate">
                            <p class="text-center">{{ stakeMinTitle }}</p>
                            <input class="text-center mw-100 border-0 bg-transparent" v-model="sliderStakeMinRange" @input="updateStakeRange($event.target.value, sliderStakeMaxRange)"/>
                        </div>
                        <hr>
                        <div class="max-rate">
                            <p class="text-center">{{ stakeMaxTitle }}</p>
                            <input class="text-center mw-100 border-0 bg-transparent" v-model="sliderStakeMaxRange" @input="updateStakeRange(sliderStakeMinRange, $event.target.value)"/>
                        </div>
                    </div>
                </div>
                <div class="dropdown-divider d-none d-sm-block"/>

                <filter-action :is-clear-disabled="clearFilterDisabled" @apply="applyFilter" @clear="clear"/>

            </div>
        </div>
    </div>

</template>

<script>
import noUiSlider from 'nouislider/distribute/nouislider.min';
import {FilterMixin} from './mixins/FilterMixin';
import CoreLibrary from "../../helpers/CoreLibrary";
import FilterAction from "./FilterAction";

export default {
    name: "RangeFilter",
    components: {FilterAction},
    mixins: [FilterMixin],
    extends: CoreLibrary,
    props: {
        label: String,
        sign: {
            type: String,
            default: ''
        },
        firstTitle: {
            type: String,
            default: function () {
                return this.filterKey == 'wdw' ? this.$t('home') : this.$t('line');
            }
        },
        firstMinTitle: {
            type: String,
            default: function () {
                return this.$t('min')
            }
        },
        firstMaxTitle: {
            type: String,
            default: function () {
                return this.$t('max')
            }
        },
        secondTitle: {
            type: String,
            default: function () {
                return this.filterKey == 'wdw' ? this.$t('draw') : (this.filterKey == 'ah' ? this.$t('home') : this.$t('over'));
            }
        },
        secondMinTitle: {
            type: String,
            default: function () {
                return this.$t('min')
            }
        },
        secondMaxTitle: {
            type: String,
            default: function () {
                return this.$t('max')
            }
        },
        thirdTitle: {
            type: String,
            default: function () {
                return this.filterKey == 'wdw' || this.filterKey == 'ah' ? this.$t('away') : this.$t('under');
            }
        },
        thirdMinTitle: {
            type: String,
            default: function () {
                return this.$t('min')
            }
        },
        thirdMaxTitle: {
            type: String,
            default: function () {
                return this.$t('max')
            }
        },
        stakeTitle: {
            type: String,
            default: function () {
                return this.$t('stake')
            }
        },
        stakeMinTitle: {
            type: String,
            default: function () {
                return this.$t('min')
            }
        },
        stakeMaxTitle: {
            type: String,
            default: function () {
                return this.$t('max')
            }
        },
        firstMaxRange: {
            default: 500
        },
        firstMinRange: {
            default: 0
        },
        secondMaxRange: {
            default: 500
        },
        secondMinRange: {
            default: 0
        },
        thirdMaxRange: {
            default: 500
        },
        thirdMinRange: {
            default: 0
        },
        stakeMaxRange: {
            default: 50000
        },
        stakeMinRange: {
            default: 0
        }
    },
    data() {
        return {
            sliderFirstMinRange: Number(this.firstMinRange),
            sliderFirstMaxRange: Number(this.firstMaxRange),
            sliderSecondMinRange: Number(this.secondMinRange),
            sliderSecondMaxRange: Number(this.secondMaxRange),
            sliderThirdMinRange: Number(this.thirdMinRange),
            sliderThirdMaxRange: Number(this.thirdMaxRange),
            sliderStakeMinRange: Number(this.stakeMinRange),
            sliderStakeMaxRange: Number(this.stakeMaxRange),
            firstRangeSlider: null,
            secondRangeSlider: null,
            thirdRangeSlider: null,
            stakeRangeSlider: null,
            value: {},
            clearFilterDisabled: true
        }
    },
    mounted() {
        this.initFirstRangeFilter();
        this.initSecondRangeFilter();
        this.initThirdRangeFilter();
        this.initStakeRangeFilter();
        this.$hub.$on('clearAllFilter-' + this.tableId, () => {
            this.resetRangeFilter();
        });
    },
    watch: {
        firstMaxRange: function () {
            this.initFirstRangeFilter();
        },
        firstMinRange: function () {
            this.initFirstRangeFilter();
        },
        secondMaxRange: function () {
            this.initSecondRangeFilter();
        },
        secondMinRange: function () {
            this.initSecondRangeFilter();
        },
        thirdMaxRange: function () {
            this.initThirdRangeFilter();
        },
        thirdMinRange: function () {
            this.initThirdRangeFilter();
        },
        stakeMaxRange: function () {
            this.initStakeRangeFilter();
        },
        stakeMinRange: function () {
            this.initStakeRangeFilter();
        },
        firstActive: {
            handler: function (firstActive) {
                if(!this.isUndefined(firstActive) && firstActive) {
                    this.initFirstRangeFilter();
                }
            }
        },
        secondActive: {
            handler: function (secondActive) {
                if(!this.isUndefined(secondActive) && secondActive) {
                    this.initSecondRangeFilter();
                }
            }
        },
        thirdActive: {
            handler: function (thirdActive) {
                if(!this.isUndefined(thirdActive) && thirdActive) {
                    this.initThirdRangeFilter();
                }
            }
        },
        stakeActive: {
            handler: function (stakeActive) {
                if(!this.isUndefined(stakeActive) && stakeActive) {
                    this.initStakeRangeFilter();
                }
            }
        }
    },
    computed: {
        isFraction() {
            return !((Number(this.minRange) % 1 === 0) && (Number(this.maxRange) % 1 === 0))
        },
        filterLabel() {
            return this.label;
        },
    },
    methods: {
        updateFirstRange(min, max) {
            min = parseFloat(min);
            max = parseFloat(max);
            if (this.firstRangeSlider) {
                this.firstRangeSlider.noUiSlider.set([min, max]);
                this.value['1'] = {'min': min, 'max': max}
            }
        },
        updateSecondRange(min, max) {
            min = parseFloat(min);
            max = parseFloat(max);
            if (this.secondRangeSlider) {
                this.secondRangeSlider.noUiSlider.set([min, max]);
                this.value['2'] = {'min': min, 'max': max}
            }
        },
        updateThirdRange(min, max) {
            min = parseFloat(min);
            max = parseFloat(max);
            if (this.thirdRangeSlider) {
                this.thirdRangeSlider.noUiSlider.set([min, max]);
                this.value['3'] = {'min': min, 'max': max}
            }
        },
        updateStakeRange(min, max) {
            min = parseFloat(min);
            max = parseFloat(max);
            if (this.stakeRangeSlider) {
                this.stakeRangeSlider.noUiSlider.set([min, max]);
                this.value['S'] = {'min': min, 'max': max}
            }
        },
        initFirstRangeFilter() {
            // First

            if(this.firstRangeSlider) {
                this.firstRangeSlider.noUiSlider.destroy();
                this.firstRangeSlider = null;
            }
            this.firstRangeSlider = document.getElementById('slider-first-' + this.filterId);
            noUiSlider.create(this.firstRangeSlider, {
                start: [Number(this.firstMinRange), Number(this.firstMaxRange)],
                step: 0.25,
                connect: true,
                disabled: false,
                range: {
                    min: [Number(this.firstMinRange)],
                    max: [Number(this.firstMaxRange)]
                },
                // tooltips: true
            });

            this.sliderFirstMinRange = Number(this.firstMinRange);
            this.sliderFirstMaxRange = Number(this.firstMaxRange);

            if(!this.isUndefined(this.firstActive) && this.firstActive) {
                this.firstRangeSlider.noUiSlider.updateOptions({
                    start: [Number(this.firstActive.min), Number(this.firstActive.max)]
                }, true);
                this.sliderFirstMinRange = Number(this.firstActive.min);
                this.sliderFirstMaxRange = Number(this.firstActive.max);
                this.isApply = true;
            }

            this.firstRangeSlider.noUiSlider.on('change', (value) => {
                this.clearFilterDisabled = false;
                this.sliderFirstMinRange = this.isFraction ? value[0] : Math.round(value[0]);
                this.sliderFirstMaxRange = this.isFraction ? value[1] : Math.round(value[1]);
                this.value['1'] = {'min': this.sliderFirstMinRange, 'max': this.sliderFirstMaxRange}
            });
        },
        initSecondRangeFilter() {
            // Second

            if(this.secondRangeSlider) {
                this.secondRangeSlider.noUiSlider.destroy();
                this.secondRangeSlider = null;
            }
            this.secondRangeSlider = document.getElementById('slider-second-' + this.filterId);
            noUiSlider.create(this.secondRangeSlider, {
                start: [Number(this.secondMinRange), Number(this.secondMaxRange)],
                step: 0.25,
                connect: true,
                disabled: false,
                range: {
                    min: [Number(this.secondMinRange)],
                    max: [Number(this.secondMaxRange)]
                },
                // tooltips: true
            });

            this.sliderSecondMinRange = Number(this.secondMinRange);
            this.sliderSecondMaxRange = Number(this.secondMaxRange);

            if(!this.isUndefined(this.secondActive) && this.secondActive) {
                this.secondRangeSlider.noUiSlider.updateOptions({
                    start: [Number(this.secondActive.min), Number(this.secondActive.mMax)]
                }, true);
                this.sliderSecondMinRange = Number(this.secondActive.min);
                this.sliderSecondMaxRange = Number(this.secondActive.max);
                this.isApply = true;
            }

            this.secondRangeSlider.noUiSlider.on('change', (value) => {
                this.clearFilterDisabled = false;
                this.sliderSecondMinRange = this.isFraction ? value[0] : Math.round(value[0]);
                this.sliderSecondMaxRange = this.isFraction ? value[1] : Math.round(value[1]);
                this.value['2'] = {'min': this.sliderSecondMinRange, 'max': this.sliderSecondMaxRange}
            });
        },
        initThirdRangeFilter() {
            // Third

            if(this.thirdRangeSlider) {
                this.thirdRangeSlider.noUiSlider.destroy();
                this.thirdRangeSlider = null;
            }
            this.thirdRangeSlider = document.getElementById('slider-third-' + this.filterId);
            noUiSlider.create(this.thirdRangeSlider, {
                start: [Number(this.thirdMinRange), Number(this.thirdMaxRange)],
                step: 0.25,
                connect: true,
                disabled: false,
                range: {
                    min: [Number(this.thirdMinRange)],
                    max: [Number(this.thirdMaxRange)]
                },
                // tooltips: true
            });

            this.sliderThirdMinRange = Number(this.thirdMinRange);
            this.sliderThirdMaxRange = Number(this.thirdMaxRange);

            if(!this.isUndefined(this.thirdActive) && this.thirdActive) {
                this.thirdRangeSlider.noUiSlider.updateOptions({
                    start: [Number(this.thirdActive.min), Number(this.thirdActive.max)]
                }, true);
                this.sliderThirdMinRange = Number(this.thirdActive.min);
                this.sliderThirdMaxRange = Number(this.thirdActive.max);
                this.isApply = true;
            }

            this.thirdRangeSlider.noUiSlider.on('change', (value) => {
                this.clearFilterDisabled = false;
                this.sliderThirdMinRange = this.isFraction ? value[0] : Math.round(value[0]);
                this.sliderThirdMaxRange = this.isFraction ? value[1] : Math.round(value[1]);
                this.value['3'] = {'min': this.sliderThirdMinRange, 'max': this.sliderThirdMaxRange}
            });
        },
        initStakeRangeFilter() {
            // Stake

            if(this.stakeRangeSlider) {
                this.stakeRangeSlider.noUiSlider.destroy();
                this.stakeRangeSlider = null;
            }
            this.stakeRangeSlider = document.getElementById('slider-stake-' + this.filterId);
            noUiSlider.create(this.stakeRangeSlider, {
                start: [Number(this.stakeMinRange), Number(this.stakeMaxRange)],
                step: 1,
                connect: true,
                disabled: false,
                range: {
                    min: [Number(this.stakeMinRange)],
                    max: [Number(this.stakeMaxRange)]
                },
                // tooltips: true
            });

            this.sliderStakeMinRange = Number(this.stakeMinRange);
            this.sliderStakeMaxRange = Number(this.stakeMaxRange);

            if(!this.isUndefined(this.stakeActive) && this.stakeActive) {
                this.stakeRangeSlider.noUiSlider.updateOptions({
                    start: [Number(this.stakeActive.min), Number(this.stakeActive.max)]
                }, true);
                this.sliderStakeMinRange = Number(this.stakeActive.min);
                this.sliderStakeMaxRange = Number(this.stakeActive.max);
                this.isApply = true;
            }

            this.stakeRangeSlider.noUiSlider.on('change', (value) => {
                this.clearFilterDisabled = false;
                this.sliderStakeMinRange = this.isFraction ? value[0] : Math.round(value[0]);
                this.sliderStakeMaxRange = this.isFraction ? value[1] : Math.round(value[1]);
                this.value["S"] = {'min': this.sliderStakeMinRange, 'max': this.sliderStakeMaxRange}
            });
        },
        applyFilter() {
            if (this.value) {
                this.isApply = true;
                this.returnValue(this.value);
            }
            this.closeDropDown();
            this.removeDropdownShow();
        },
        resetRangeFilter() {
            this.firstRangeSlider.noUiSlider.reset();
            this.secondRangeSlider.noUiSlider.reset();
            this.thirdRangeSlider.noUiSlider.reset();
            this.stakeRangeSlider.noUiSlider.reset();
            this.sliderFirstMinRange = Number(this.firstMinRange);
            this.sliderFirstMaxRange = Number(this.firstMaxRange);
            this.sliderSecondMinRange = Number(this.secondMinRange);
            this.sliderSecondMaxRange = Number(this.secondMaxRange);
            this.sliderThirdMinRange = Number(this.thirdMinRange);
            this.sliderThirdMaxRange = Number(this.thirdMaxRange);
            this.sliderStakeMinRange = Number(this.stakeMinRange);
            this.sliderStakeMaxRange = Number(this.stakeMaxRange);
            this.isApply = false;
            this.value = {};
            this.clearFilterDisabled = true;
        },
        clear(event) {
            event.stopPropagation();
            this.removeDropdownShow();
            this.resetRangeFilter();
            this.returnValue(this.value);
        }
    }
}
</script>
